import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import CalendarPicker from '@rsos/base-components/CalendarPicker';
import { THIRTY_DAYS } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import { SESSION_TYPES } from '../../../constants';
import styles from './ConversationHistory.module.scss';

interface ToolbarProps {
  availableSessionTypes: typeof SESSION_TYPES;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  startDate: Date;
  endDate: Date;
  now: number;
  onStartDateChange: (date: Date) => void;
  onEndDateChange: (date: Date) => void;
  selectedTypes: string[];
  onToggleType: (value: string) => void;
  filteredConversationIds: string[];
  hasAnyChecked: boolean;
  checkedIds: string[];
  onDownload: (ids: string[]) => void;
  isDownloading: boolean;
}

const Toolbar = ({
  availableSessionTypes,
  searchTerm,
  onSearchChange,
  startDate,
  endDate,
  now,
  onStartDateChange,
  onEndDateChange,
  selectedTypes,
  onToggleType,
  filteredConversationIds,
  hasAnyChecked,
  checkedIds,
  onDownload,
  isDownloading,
}: ToolbarProps) => {
  return (
    <div className={styles.toolbar}>
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Search</span>
        <div className={styles.searchWrapper}>
          <span className={styles.searchIcon}>
            <MagnifyingGlassIcon width={14} height={14} />
          </span>
          <input
            className={styles.searchInput}
            type="text"
            placeholder="Phone number..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.filterDivider} />

      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Date Range</span>
        <div className={styles.dateRange}>
          <CalendarPicker
            selectedDate={startDate}
            onChange={date => date && onStartDateChange(date)}
            popperPlacement="bottom-start"
            minDate={new Date(now - THIRTY_DAYS)}
            maxDate={endDate}
          />
          <span className={styles.dateSeparator}>–</span>
          <CalendarPicker
            selectedDate={endDate}
            onChange={date => date && onEndDateChange(date)}
            popperPlacement="bottom-start"
            minDate={startDate}
            maxDate={new Date(now)}
          />
        </div>
      </div>

      <div className={styles.filterDivider} />

      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Type</span>
        <div className={styles.typeFilter}>
          {availableSessionTypes.map(({ value, label }) => (
            <button
              key={value}
              className={`${styles.typeChip}${selectedTypes.includes(value) ? ` ${styles.typeChipActive}` : ''}`}
              onClick={() => onToggleType(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.downloadGroup}>
        <button
          className={styles.downloadBtn}
          onClick={() =>
            hasAnyChecked
              ? onDownload(checkedIds)
              : onDownload(filteredConversationIds)
          }
          disabled={filteredConversationIds.length === 0 || isDownloading}
        >
          Download {hasAnyChecked ? 'Selected' : 'All'}
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
